import { Feather, AntDesign } from "@expo/vector-icons";
import { router } from "expo-router";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Text, View, SafeAreaView, TextInput, Pressable } from "react-native";
import Toast from "react-native-toast-message";

import Email from "@/assets/email.svg";
import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Loader from "@/components/Loader";
import Button from "@/components/button/Button";
import { sendRequest } from "@/utils/ApiUtil";

type FormData = {
  code: string;
};

export default function Validate() {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [isCodeSend, setIsCodeSend] = useState(false);

  const { handleSubmit, formState, setValue } = useForm<FormData>({
    mode: "onSubmit",
  });
  const { isSubmitting } = formState;

  useEffect(() => {
    if (isCodeSend) {
      setTimeout(() => {
        Toast.hide();
        setIsCodeSend(false);
      }, 300000);
    }
  }, [isCodeSend]);

  const onSubmit = async () => {
    try {
      const request = await sendRequest(
        "POST",
        "/validate-email",
        { code },
        true
      );
      if (request) {
        router.replace("/welcome");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleResendCode = () => {
    if (isCodeSend) {
      Toast.show({
        type: "error",
        autoHide: false,
        props: {
          text1: t("common:toast.error"),
          text2: t("common:toast.subtitle.codealreadysent"),
        },
      });
    } else {
      const request = sendRequest("GET", "/get-validation-code", null, true);
      if (request) {
        Toast.show({
          type: "success",
          visibilityTime: 4000,
          props: {
            text1: t("common:toast.success"),
            text2: t("common:toast.subtitle.codesentagain"),
          },
        });
        setIsCodeSend(true);
      }
    }
  };

  return (
    <SafeAreaView className="grow bg-white1">
      <View className="items-center w-full h-full p-2">
        <View className="items-center h-5/6 w-full">
          <Logo className="m-2" />
          <View className="my-2">
            <Text className="text-blue1 text-4xl text-center font-medium">
              {t("validate:title")}
            </Text>
          </View>
          <Text className="text-midgray font-medium text-base text-center">
            {t("validate:subtitle")}
          </Text>
          <View className="flex-grow items-center justify-center">
            <View className="mb-3">
              <Email width={120} height={120} />
            </View>
            <TextInput
              className="border-2 rounded border-lightgray text-4xl font-light bg-white1 text-center py-2"
              value={code}
              placeholder={t("validate:placeholder")}
              placeholderTextColor="#DFDFDF"
              onChangeText={(text) => {
                const filteredText = text.replace(/\D/g, "");
                setCode(filteredText);
                setValue("code", filteredText);
              }}
              keyboardType="numeric"
            />
          </View>
          <Button
            label={t("common:button.confirm")}
            onClick={handleSubmit(onSubmit)}
          />
          <Pressable
            className="items-center justify-center flex-row w-full"
            onPress={handleResendCode}
          >
            <Text className="text-sm text-darkergray mx-2">
              {t("validate:sendagain")}
            </Text>
            {isCodeSend ? (
              <AntDesign name="check" size={12} color="#919191" />
            ) : (
              <Feather name="rotate-ccw" size={12} color="#919191" />
            )}
          </Pressable>
        </View>
        <View className="flex-grow justify-end items-end">
          <Copyright />
        </View>
      </View>
      {isSubmitting && <Loader />}
    </SafeAreaView>
  );
}
